module.exports = __webpack_public_path__ + "static/media/burger-menu-close.1a9b78ad.svg";